/**
 * Load more
 */

import $ from 'jquery';

$('.js-load-more').on('click', function(e) {
	e.preventDefault();

	$(this)
		.closest('.js-categories')
		.find('.js-category.is-hidden')
			.slideToggle();

	$(this).hide();
})